export const SESSION_STORAGE_KEYS = {
  FIREBASE_APP_ID: 'firebaseAppId',
  SEND_ANALYTICS: 'send_analytics',
  HIDE_NAVIGATION: 'hide_navigation',
  ONBOARDING_ADDRESS_FORM_VIEW_TYPE: 'onboarding_address_form_view_type',
}
